// extracted by mini-css-extract-plugin
export default {"container":"VideoList_container__qTaPe","cardContainer":"VideoList_cardContainer__AEjOD"};